export const GENDER = {
	male: 'Masculino',
	female: 'Feminino'
};
